module.exports = __webpack_public_path__ + "static/media/matted-3mm-foam-cello-bag.deeb6dd9.jpeg";